import { lazy, Suspense } from 'react';
import PageMetaLoader from '../components/PageMetaLoader';
import OrganizationJsonLd from '../components/OrganizationJsonLd';
import { useI18n } from '../i18n';

const DynamicHero = lazy(() => import('../components/Hero'));
const DynamicProcessSection = lazy(() => import('../components/ProcessSection'));
const DynamicModulesSection = lazy(() => import('../components/ModulesSection'));
const DynamicPlatformSection = lazy(() => import('../components/PlatformSection'));
const DynamicFeaturesSection = lazy(() => import('../components/FeaturesSection'));
const DynamicTestimonialsSection = lazy(() => import('../components/TestimonialsSection'));

const HomePage = () => {
  const { t } = useI18n();
  return (
    <div>
      <PageMetaLoader pageUrl="home" />
      <OrganizationJsonLd />
      <Suspense fallback={<div className="container" style={{ padding: '4rem 1rem' }}>{t.loading}</div>}>
        <DynamicHero />
        <DynamicProcessSection />
        <DynamicModulesSection />
        <DynamicPlatformSection />
        <DynamicFeaturesSection />
        <DynamicTestimonialsSection />
      </Suspense>
    </div>
  );
};

export default HomePage;
